const validEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

function isValidEmail(email?: string): boolean {
  if (email === '') {
    return false
  }

  const match = String(email).toLowerCase().match(validEmailRegex)
  if (match && match.length > 0) {
    return true
  }

  return false
}

const validPasswordRegex = /^.{6,}$/

function isValidPassword(pass: string): boolean {
  if (!pass || pass === '') {
    return false
  }

  const match = validPasswordRegex.test(pass)
  return match
}

export { isValidEmail, validEmailRegex, validPasswordRegex, isValidPassword }
